import script from "./ClubPageMembersTableRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPageMembersTableRegistration.vue?vue&type=script&setup=true&lang=js"

import "./ClubPageMembersTableRegistration.vue?vue&type=style&index=0&id=5248dc58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5248dc58"]])

export default __exports__